import { render } from "./icon-location-pin.vue?vue&type=template&id=268bb04c"
import script from "./icon-location-pin.vue?vue&type=script&lang=js"
export * from "./icon-location-pin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__